<template>
  <li @click="action">
    <!-- 收藏collect 已收藏collected -->
    <i :class="{'collected':isCollected}" class="collect" style="margin: 0 auto;"></i>
    <span>{{isCollected?"已收藏":"收藏"}}</span>
  </li>
</template>
<script>
import Constants from '@/js/constants.js'
export default {
  name: 'collect',
  props: {
    type: {
      type: String,
      required: true
    },
    resourceId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      isCollected: false,
      collectionType: ''
    }
  },
  methods: {
    initCollectState() {
      this.$fetch('/api/Collection/IsCollected', {
        resourceId: this.resourceId,
        type: this.collectionType
      })
        .then(result => {
          this.isCollected = result
        })
        .catch(result => {
          // un login
        })
    },
    action() {
      if (this.isCollected) {
        this.cancel()
      } else {
        this.add()
      }
    },
    add() {
      this.$post('/api/Collection/Collect', {
        collectionId: this.resourceId,
        type: this.collectionType
      })
        .then(result => {
          this.isCollected = true
          this.$dialog.toast({
            mes: '收藏成功',
            icon: 'success',
            timeout: 1500
          })
        })
        .catch(result => {
          if (result.UnAuthorizedRequest) {
            this.$dialog.toast({
              mes: '您还没有登录，不能进行收藏',
              timeout: 2500
            })
          } else {
            this.$dialog.toast({
              mes: result.Error.Message,
              timeout: 2500
            })
          }
        })
    },
    cancel() {
      this.$post('/api/Collection/Cancel', {
        resourceId: this.resourceId,
        type: this.collectionType
      })
        .then(result => {
          this.isCollected = false
          this.$dialog.toast({
            mes: '取消成功',
            icon: 'success',
            timeout: 1500
          })
        })
        .catch(result => {
          this.$dialog.toast({
            mes: result.Error.Message,
            timeout: 2500
          })
        })
    }
  },
  created() {
    this.collectionType = Constants.collectionType[this.type]
    this.initCollectState()
  }
}
</script>

<style lang="less" scoped>
i {
  display: block;
  width: 46 / @rem-size;
  height: 44 / @rem-size;
  margin: 0 auto;
  background-image: url('../assets/images/activity-icon.png');
  background-size: 184 / @rem-size 44 / @rem-size;
  background-position: -46 / @rem-size 0;

  &.collected {
    background-position: -92 / @rem-size 0 !important;
  }
}
</style>
